import { render } from "./Message.vue?vue&type=template&id=41afc865"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script